const Colours = [
  { label: 'Black', value: 'black' },
  { label: 'Blue', value: 'blue' },
  { label: 'Pink', value: 'pink' },
  { label: 'Purple', value: 'purple' },
  { label: 'Red', value: 'red' },
  { label: 'Green', value: 'green' },
  { label: 'Grey', value: 'grey' },
  { label: 'Silver', value: 'silver' },
  { label: 'White', value: 'white' },
  { label: 'Orange', value: 'orange' },
  { label: 'Other', value: 'other' },
  { label: 'Yellow', value: 'yellow' },
]

export default Colours
